import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import message from './utils/message'

// 设置网页标题
document.title = '小葱聊天室';

// 初始化右键菜单（在 Vue 应用启动前）
(function() {
  console.log('开始注入全局右键菜单监听器...')
  
  let showContextMenu = false
  let contextMenuShowTime = 0
  let contextMenuElement = null
  let contextMenuTarget = null
  
  function createContextMenu() {
    if (contextMenuElement) return contextMenuElement
    const menu = document.createElement('div')
    menu.className = 'context-menu'
    menu.style.cssText = 'position:fixed;background:white;border:1px solid #e0e0e0;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.15);min-width:180px;z-index:99999;padding:4px 0;font-size:14px;display:none;'
    document.body.appendChild(menu)
    contextMenuElement = menu
    return menu
  }
  
  function addMenuStyles() {
    if (document.getElementById('context-menu-styles')) return
    const style = document.createElement('style')
    style.id = 'context-menu-styles'
    style.textContent = `.context-menu{position:fixed;background:white;border:1px solid #e0e0e0;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.15);min-width:180px;z-index:99999;padding:4px 0;font-size:14px}.context-menu-item{padding:10px 16px;display:flex;align-items:center;cursor:pointer;transition:background 0.2s;color:#333;user-select:none}.context-menu-item:hover:not(.disabled):not(.divider){background:#f5f5f5}.context-menu-item.disabled{color:#999;cursor:not-allowed;opacity:0.5}.context-menu-item.divider{height:1px;padding:0;margin:4px 0;background:#e0e0e0;cursor:default}.context-menu-item.danger{color:#f44336}.context-menu-item.danger:hover{background:#ffebee;color:#d32f2f}.menu-icon{margin-right:8px;font-size:16px;width:20px;text-align:center}.menu-text{flex:1}.menu-shortcut{margin-left:16px;color:#999;font-size:12px}`
    document.head.appendChild(style)
  }
  
  function showMenu(x, y, items) {
    const menu = createContextMenu()
    showContextMenu = true
    contextMenuShowTime = Date.now()
    menu.innerHTML = items.map((item) => {
      if (item.divider) return '<div class="context-menu-item divider"></div>'
      const icon = item.icon ? `<span class="menu-icon">${item.icon}</span>` : ''
      const shortcut = item.shortcut ? `<span class="menu-shortcut">${item.shortcut}</span>` : ''
      const danger = item.danger ? 'danger' : ''
      const disabled = item.disabled ? 'disabled' : ''
      return `<div class="context-menu-item ${danger} ${disabled}" data-action="${item.action || ''}">${icon}<span class="menu-text">${item.label}</span>${shortcut}</div>`
    }).join('')
    
    // 为每个菜单项添加点击事件监听器
    menu.querySelectorAll('.context-menu-item:not(.divider):not(.disabled)').forEach(item => {
      item.addEventListener('click', handleMenuItemClick)
    })
    
    menu.style.left = x + 'px'
    menu.style.top = y + 'px'
    menu.style.display = 'block'
    setTimeout(() => {
      const rect = menu.getBoundingClientRect()
      let newX = Math.max(10, Math.min(x, window.innerWidth - rect.width - 10))
      let newY = Math.max(10, Math.min(y, window.innerHeight - rect.height - 10))
      menu.style.left = newX + 'px'
      menu.style.top = newY + 'px'
    }, 0)
    console.log('✅ 右键菜单已显示')
  }
  
  function hideMenu() {
    if (contextMenuElement) contextMenuElement.style.display = 'none'
    showContextMenu = false
    contextMenuTarget = null
  }
  
  // 处理全局操作（不依赖 Vue 组件）
  function handleGlobalAction(action, target) {
    switch (action) {
      case 'refresh':
        // 刷新页面
        window.location.reload()
        return true
        
      case 'copy':
        // 复制操作
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.closest('input') || target.closest('textarea')) {
          // 输入框复制
          const inputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' ? target : (target.closest('input') || target.closest('textarea'))
          if (inputElement && inputElement.selectionStart !== inputElement.selectionEnd) {
            const selectedText = inputElement.value.substring(inputElement.selectionStart, inputElement.selectionEnd)
            navigator.clipboard.writeText(selectedText).then(() => {
              console.log('✅ 已复制:', selectedText)
            }).catch(err => {
              console.error('复制失败:', err)
              // 降级方案：使用 execCommand
              inputElement.select()
              document.execCommand('copy')
            })
            return true
          }
        } else {
          // 普通文本复制（包括消息区域）
          const selection = window.getSelection()
          let textToCopy = ''
          
          // 优先使用选中的文本
          if (selection && selection.toString().trim().length > 0) {
            textToCopy = selection.toString()
          } else if (target.closest('.message-item')) {
            // 如果没有选中文本，尝试复制整个消息内容
            const messageItem = target.closest('.message-item')
            const messageContent = messageItem.querySelector('.message-content')
            if (messageContent) {
              textToCopy = messageContent.textContent || messageContent.innerText || ''
            } else {
              textToCopy = messageItem.textContent || ''
            }
            textToCopy = textToCopy.trim()
          }
          
          if (textToCopy) {
            navigator.clipboard.writeText(textToCopy).then(() => {
              console.log('✅ 已复制:', textToCopy)
            }).catch(err => {
              console.error('复制失败:', err)
              // 降级方案
              const textarea = document.createElement('textarea')
              textarea.value = textToCopy
              textarea.style.position = 'fixed'
              textarea.style.opacity = '0'
              document.body.appendChild(textarea)
              textarea.select()
              document.execCommand('copy')
              document.body.removeChild(textarea)
            })
            return true
          }
        }
        return false
        
      case 'cut':
        // 剪切操作（仅适用于输入框）
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.closest('input') || target.closest('textarea')) {
          const inputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' ? target : (target.closest('input') || target.closest('textarea'))
          if (inputElement && inputElement.selectionStart !== inputElement.selectionEnd) {
            const selectedText = inputElement.value.substring(inputElement.selectionStart, inputElement.selectionEnd)
            navigator.clipboard.writeText(selectedText).then(() => {
              // 删除选中的文本
              const start = inputElement.selectionStart
              const end = inputElement.selectionEnd
              const value = inputElement.value
              inputElement.value = value.substring(0, start) + value.substring(end)
              inputElement.setSelectionRange(start, start)
              inputElement.dispatchEvent(new Event('input', { bubbles: true }))
              console.log('✅ 已剪切:', selectedText)
            }).catch(err => {
              console.error('剪切失败:', err)
              // 降级方案
              inputElement.select()
              document.execCommand('cut')
            })
            return true
          }
        }
        return false
        
      case 'paste':
        // 粘贴操作（仅适用于输入框）
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.closest('input') || target.closest('textarea')) {
          const inputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' ? target : (target.closest('input') || target.closest('textarea'))
          if (inputElement) {
            inputElement.focus()
            navigator.clipboard.readText().then(text => {
              const start = inputElement.selectionStart || 0
              const end = inputElement.selectionEnd || 0
              const value = inputElement.value || ''
              const textBefore = value.substring(0, start)
              const textAfter = value.substring(end)
              const newValue = textBefore + text + textAfter
              
              // 更新输入框的值
              inputElement.value = newValue
              
              // 触发 input 事件，确保 v-model 更新
              inputElement.dispatchEvent(new Event('input', { bubbles: true }))
              
              // 设置光标位置
              setTimeout(() => {
                inputElement.setSelectionRange(start + text.length, start + text.length)
              }, 0)
              
              console.log('✅ 已粘贴:', text)
            }).catch(err => {
              console.error('粘贴失败:', err)
            })
            return true
          }
        }
        return false
        
      case 'selectAll':
        // 全选操作（仅适用于输入框）
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.closest('input') || target.closest('textarea')) {
          const inputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' ? target : (target.closest('input') || target.closest('textarea'))
          if (inputElement) {
            inputElement.focus()
            inputElement.select()
            console.log('✅ 已全选')
            return true
          }
        }
        return false
        
      case 'clear':
        // 清空操作（仅适用于输入框）
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.closest('input') || target.closest('textarea')) {
          const inputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' ? target : (target.closest('input') || target.closest('textarea'))
          if (inputElement) {
            inputElement.value = ''
            // 触发 input 事件，确保 v-model 更新
            inputElement.dispatchEvent(new Event('input', { bubbles: true }))
            inputElement.focus()
            console.log('✅ 已清空')
            return true
          }
        }
        return false
        
      default:
        return false
    }
  }
  
  function handleContextMenu(event) {
    const target = event.target
    
    // 如果点击在消息区域、用户列表项或聊天容器内，让Vue组件处理
    // Vue组件可以访问userInfo等数据，并且需要处理聊天区域的空白处
    if (target.closest('.message-item') || 
        target.closest('.user-item') || 
        target.closest('.chat-messages') ||
        target.closest('.chat-container') ||
        target.closest('.chat-wrapper') ||
        target.closest('.chat-panel') ||
        target.closest('.user-list-panel')) {
      // 完全停止处理，让Vue组件的handleContextMenu处理
      // 不阻止事件，让Vue组件可以处理
      return
    }
    
    // 阻止默认右键菜单
    event.preventDefault()
    event.stopPropagation()
    let menuItems = []
    
    if (target.closest('.user-item')) {
      // 用户列表项由 Vue 组件处理，这里不处理
      return
    } else if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.closest('input') || target.closest('textarea')) {
      const inputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' ? target : (target.closest('input') || target.closest('textarea'))
      const hasSelection = inputElement && inputElement.selectionStart !== inputElement.selectionEnd
      const hasText = inputElement && inputElement.value && inputElement.value.length > 0
      
      menuItems = []
      
      // 如果有选中的文本，显示复制和剪切
      if (hasSelection) {
        menuItems.push(
          { label: '复制', icon: '📋', action: 'copy', shortcut: 'Ctrl+C' },
          { label: '剪切', icon: '✂️', action: 'cut', shortcut: 'Ctrl+X' }
        )
      }
      
      // 粘贴选项
      menuItems.push({ label: '粘贴', icon: '📋', action: 'paste', shortcut: 'Ctrl+V' })
      
      // 如果有选中文本或文本内容，添加分隔符
      if (hasSelection || hasText) {
        menuItems.push({ divider: true })
      }
      
      // 全选
      menuItems.push({ label: '全选', icon: '✓', action: 'selectAll', shortcut: 'Ctrl+A' })
      
      // 如果有文本，添加清空选项
      if (hasText) {
        menuItems.push({ divider: true })
        menuItems.push({ label: '清空', icon: '🗑️', action: 'clear' })
      }
    } else {
      // 检查是否有选中的文本（用于复制）
      const selection = window.getSelection()
      const hasTextSelection = selection && selection.toString().trim().length > 0
      
      menuItems = []
      
      // 如果有选中的文本，显示复制选项
      if (hasTextSelection) {
        menuItems.push({ label: '复制', icon: '📋', action: 'copy', shortcut: 'Ctrl+C' })
        menuItems.push({ divider: true })
      }
      
      // 刷新选项
      menuItems.push({ label: '刷新', icon: '🔄', action: 'refresh', shortcut: 'F5' })
      menuItems.push({ divider: true })
      // 主题切换选项 - 检查当前是否是夜间模式
      const isDarkMode = document.documentElement.classList.contains('dark-mode')
      menuItems.push({ 
        label: isDarkMode ? '切换到白天模式' : '切换到夜间模式', 
        icon: isDarkMode ? '☀️' : '🌙', 
        action: 'toggleTheme' 
      })
    }
    contextMenuTarget = target
    showMenu(event.clientX, event.clientY, menuItems)
  }
  
  // 处理菜单项点击
  function handleMenuItemClick(event) {
    event.preventDefault()
    event.stopPropagation()
    const item = event.target.closest('.context-menu-item')
    if (item && !item.classList.contains('divider') && !item.classList.contains('disabled')) {
      const action = item.dataset.action
      console.log('✅ 菜单项被点击:', action, '目标:', contextMenuTarget)
      
      // 先尝试在全局处理一些基本操作
      if (handleGlobalAction(action, contextMenuTarget)) {
        console.log('✅ 全局处理成功:', action)
        hideMenu()
        return
      }
      
      // 如果全局处理不了，发送自定义事件让 Vue 组件处理
      console.log('发送自定义事件给 Vue 组件:', action, '目标:', contextMenuTarget)
      const customEvent = new CustomEvent('contextmenu-action', { 
        detail: { action, target: contextMenuTarget },
        bubbles: true,
        cancelable: true
      })
      console.log('事件详情:', customEvent.detail)
      const dispatched = document.dispatchEvent(customEvent)
      console.log('事件已发送，是否被阻止:', !dispatched)
      hideMenu()
    }
  }
  
  function handleMouseDown(event) {
    if (!showContextMenu) return
    if (Date.now() - contextMenuShowTime < 100) return
    if (event.button === 2) return
    
    if (contextMenuElement && contextMenuElement.contains(event.target)) {
      // 点击在菜单内部，不关闭菜单，让 click 事件处理
      return
    }
    
    // 点击在菜单外部，关闭菜单
    hideMenu()
  }
  
  addMenuStyles()
  document.addEventListener('contextmenu', handleContextMenu, true)
  document.addEventListener('mousedown', handleMouseDown, true)
  console.log('✅ 全局右键菜单监听器已添加！')
})()

const app = createApp(App)

// 将消息提示方法挂载到 Vue 原型上
app.config.globalProperties.$message = message

app.use(router).mount('#app')
